module.exports = __webpack_public_path__ + "img/unknow-icon.2aa25f79.png";